<ms-text-container *ngIf="textsController">
  <!-- В режиме Исчезающий текст конвертация в PDF запрещена из-за особенностей режима -->
  @if (text && !isTextLoading && !isExercise && !isRemotePlayer()) {
    <div
      class="pdf-converter"
      (click)="activeTransform !== 'textBlinding' ? textsController.openPreviewPDFDialog() : this.showConverterError()"
      [matTooltip]="'speedreading.convertedToPdf' | translate"
      matTooltipPosition="below"
    >
      <i class="far fa-file-pdf"></i>
    </div>
  }
  <div class="text-wrapper" [ngClass]="orientation" [style.fontSize.%]="fontSize">
    <div 
      class="text" 
      #textContainer 
      *ngIf="text && !isTextLoading; else loading"
      [msBlindsManager]="isBlind"
      [titleSelector]="'.title'"
      [paragraphsSelector]="'.paragraphs'"
      [isBook]="isBook"
      [blindSide]="blindSide"
      [blindWidth]="blindWidth"
      [blindBackgroundColor]="textsController.blindBackgroundColor">
      <!-- Контейнер для шторок - директива будет его использовать -->
      <div *ngIf="isBlind" class="blinds"></div>
      <div #textTitle class="title" [ngClass]="{ rotate: isRotate, 'line-through': isLineThrough }">
        {{ text.title }}
      </div>
      <div
        *ngIf="!rotateAnimationMode && !textBlindingMode && orientation !== 'book'"
        #textParagraphs
        class="paragraphs"
        [ngClass]="{
          rotate: isRotate,
          'line-through': isLineThrough && !isCobweb,
        }"
        [style.background-image]="
          isLineThrough && isCobweb ? 'url(' + '/assets/images/pautina.png)' : 'none'
        "
        [style.background-size]="containOrCoverWeb"
      >
        <p
          *ngFor="let p of text.paragraphs"
          [style.fontFamily]="font"
          [style]="activeTransform === 'join' ? 'word-break: break-all;' : ''"
        >
          {{ p }}
        </p>
      </div>

      <div
        *ngIf="
          orientation === 'book' &&
          activeTransform !== 'textBlinding' &&
          activeTransform !== 'rotateAnimation'
        "
        #textParagraphs
        class="book-wrap"
      >
        <div *ngIf="activePage !== 0" class="arrow left" (click)="textsController.nextPage(false)">
          <i class="fas fa-arrow-left"></i>
        </div>

        <div
          *ngIf="activePage + 1 !== pages - 1 && pages !== 1 && activePage + 1 !== pages"
          class="arrow right"
          (click)="textsController.nextPage(true)"
        >
          <i class="fas fa-arrow-right"></i>
        </div>

        <div [ngClass]="theme" #firstPage class="page-wrap one transitions">
          <span class="page-number">{{ activePage + 1 }}</span>
          <p
            [style.fontFamily]="font"
            [ngClass]="{ rotate: isRotate, 'line-through': isLineThrough }"
          >
            {{ pagesArr[activePage] }}
          </p>
        </div>
        <div [ngClass]="theme" class="page-wrap one transitions fake">
          <span class="page-number">{{ activePage + 1 }}</span>
          <p
            [style.fontFamily]="font"
            [ngClass]="{ rotate: isRotate, 'line-through': isLineThrough }"
          >
            {{ pagesArr[activePage] }}
          </p>
        </div>
        <div
          @openClose
          [ngClass]="theme"
          #secondPage
          *ngIf="pagesArr[activePage + 1]"
          class="page-wrap two transitions"
        >
          <span class="page-number">{{ activePage + 2 }}</span>
          <p
            [style.fontFamily]="font"
            [ngClass]="{ rotate: isRotate, 'line-through': isLineThrough }"
          >
            {{ pagesArr[activePage + 1] }}
          </p>
        </div>
        <div
          @openClose
          [ngClass]="theme"
          *ngIf="pagesArr[activePage + 1]"
          class="page-wrap two fake"
        >
          <span class="page-number">{{ activePage + 2 }}</span>
          <p
            [style.fontFamily]="font"
            [ngClass]="{ rotate: isRotate, 'line-through': isLineThrough }"
          >
            {{ pagesArr[activePage + 1] }}
          </p>
        </div>
      </div>

      <div
        *ngIf="rotateAnimationMode && text!.paragraphsWithWordArr"
        #textParagraphs
        class="paragraphs"
      >
        <div *ngFor="let paragraph of text.paragraphs">
          <p
            *ngFor="let letter of getLetters(paragraph); index as index"
            class="letter rotating-letters"
            [style.fontFamily]="font"
            [style.animation-duration]="4 - rotateSpeed / 1000 + 's'"
            [style.animation-direction]="index % 2 === 0 ? 'reverse' : 'normal'"
          >
            {{ letter }}
          </p>
        </div>
      </div>

      <div
        *ngIf="textBlindingMode && text!.paragraphsWithWordArr"
        #textParagraphs
        class="paragraphs"
      >
        <button
          msGameButton
          color="orange"
          style="border: 1px solid gray"
          *ngIf="!textsController.readingStatus"
          (click)="textsController.startBlindingAndReading()"
        >
          {{ 'texts.readStart' | translate }}
        </button>

        <div *ngIf="readingStatus">
          <span
            [style.fontFamily]="textsController.font"
            *ngFor="let word of textsController.text.paragraphsWithWordArr; index as index"
            [class]="blindIter < index ? 'blind-word' : 'blind-word blinded'"
            [style.transition]="0.2 + 's linear'"
          >
            {{ word + ' ' }}
          </span>
        </div>

        <button msGameButton color="orange" style="border: 1px solid gray" (click)="textsController.stopRead()">
          {{ 'texts.stop' | translate }}
        </button>
      </div>

    </div>

    <ng-template #loading>
      <div class="loading">{{ 'texts.loading' | translate }}...</div>
    </ng-template>
  </div>
  <ms-speed-reading-footer *ngIf="!isPreviewMode">
    <button *ngIf="textsController.text && !textsController.isTextLoading" ms-speed-reading-footer-button (click)="textsController.readed()">
      {{ 'texts.readed' | translate }}
    </button>
    <button *ngIf="textsController.isTextLoading" ms-speed-reading-footer-button (click)="textsController.stop()">
      {{ 'texts.stop' | translate }}
    </button>
  </ms-speed-reading-footer>
</ms-text-container>
